import ReactECharts from 'echarts-for-react';

import { fmt1 } from '../../shared/utils/stat-helpers';

interface MiniBarChartProps {
  label: string;
  value: number;
  max: number;
  suffix?: string;
  height?: string;
}

function buildOption(label: string, value: number, max: number, suffix: string, trackColor: string) {
  return {
    grid: { left: 10, right: 10, top: 8, bottom: 8, containLabel: false },
    xAxis: { type: 'value', max, show: false },
    yAxis: { type: 'category', data: [label], show: false },
    tooltip: {
      trigger: 'item',
      formatter: () => `<b>${label}</b><br/>${fmt1(value)}${suffix} / ${fmt1(max)}${suffix}`,
    },
    series: [
      {
        type: 'bar',
        data: [value],
        barWidth: 14,
        label: { show: true, position: 'insideRight', formatter: `${fmt1(value)}${suffix}` },
        itemStyle: { borderRadius: 8 },
      },
      {
        type: 'bar',
        data: [max],
        barWidth: 14,
        barGap: '-100%',
        itemStyle: { color: trackColor, borderRadius: 8 },
        silent: true,
      },
    ],
  };
}

export function MiniBarChart({ label, value, max, suffix = '', height = '56px' }: MiniBarChartProps) {
  const trackColor = getComputedStyle(document.documentElement).getPropertyValue('--edge').trim() || '#2a2419';
  return (
    <div style={{ height }}>
      <ReactECharts option={buildOption(label, value, max, suffix, trackColor)} style={{ height: '100%' }} />
    </div>
  );
}
